import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

import { maskCurrency } from '../../utils/masks'

const Icms = (props) => (
  <CRUDIndex
    title='Alíquotas de ICMS'
    icon='percent'
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} textAlign='center'
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'
            onClick={props.handleSort('submercado.sigla')}
            sorted={props.handleSorted('submercado.sigla')}>UF</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'
            onClick={props.handleSort('classe_consumo.nome')}
            sorted={props.handleSorted('classe_consumo.nome')}>Classe de Consumo</Table.HeaderCell>
          <Table.HeaderCell width={2} textAlign='center'
            onClick={props.handleSort('aliquota')}
            sorted={props.handleSorted('aliquota')}>Alíquota (%)</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='5'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleIcms.valueSeq().map((icms, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/icms/${icms.get('id')}`}>{icms.get('id')}</Label>
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/uf/${icms.getIn(['uf', 'id'])}`}>
                {icms.getIn(['uf', 'sigla'])}
              </Label>
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/classes_consumo/${icms.getIn(['classe_consumo', 'id'])}`}>
                {icms.getIn(['classe_consumo', 'nome'])}
              </Label>
            </Table.Cell>
            <Table.Cell textAlign='center'>{maskCurrency.parse(icms.get('aliquota') * 100)}</Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(icms.get('id'))}
                onDeleteResource={() => props.onDeleteResource(icms.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

Icms.propTypes = {
  onRedirectToNew: PropTypes.func,
  multipleIcms: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default Icms
